import SummaryByDealerTable from "./summaryByDealerTable.container";

export default SummaryByDealerTable;
